import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CoreButtons from "../../core-components/button/CoreButtons";
import { BUTTON_COLOR, BUTTON_VARIANT } from "../../../types/coreButtonTypes";
import EditQuoteIcon from "../../../assets/svg-fc/EditQuoteIcon";
import ViewQuoteIcon from "../../../assets/svg-fc/ViewQuoteIcon";
import { IAdmin } from "../../../types/userType";
import "./quoteCard.scss";

interface QuoteCardProps {
	quoteAmount: string;
	quoteDate?: string;
	notes?: string;
	isLatest?: boolean;
	isApproved?: boolean;
	showEditButton?: boolean;
	bidSubmittedByAdmin?: IAdmin | null;
	onEditQuote?: () => void;
	onViewQuote?: () => void;
}

const QuoteCard: React.FC<QuoteCardProps> = ({
	quoteAmount,
	quoteDate,
	notes,
	onEditQuote,
	onViewQuote,
	isLatest = false,
	isApproved = false,
	showEditButton = false,
	bidSubmittedByAdmin = null,
}) => {
	return (
		<Box className="quoteCard">
			<Box className="quoteCardContent">
				{quoteDate && <Typography className="quoteCardDate">Quote sent on {quoteDate}</Typography>}
				<Box className="quoteCardAmountRow">
					<Typography className="quoteCardAmount">AED {quoteAmount}</Typography>
					{isLatest && <Box className="quoteCardBadge">{isApproved ? "Paid" : "In talks"}</Box>}
				</Box>
				{bidSubmittedByAdmin?.id && <Typography className="quoteCardSubmittedByText">Quoted by YouCater admin</Typography>}
				{notes && (
					<Typography className="quoteCardNotes">
						Notes: <span className="quoteCardNotes_value">{notes}</span>
					</Typography>
				)}
			</Box>

			<Box className="quoteCardActions">
				{showEditButton && (
					<CoreButtons
						className="quoteCardButton"
						variant={BUTTON_VARIANT.OUTLINED}
						coreBtnPill={true}
						buttonText="Edit quote"
						color={BUTTON_COLOR.SECONDARY}
						startIcon={<EditQuoteIcon />}
						onclick={onEditQuote}
					/>
				)}
				<CoreButtons
					className="quoteCardButton"
					variant={BUTTON_VARIANT.OUTLINED}
					coreBtnPill={true}
					buttonText="View quote"
					color={BUTTON_COLOR.SECONDARY}
					startIcon={<ViewQuoteIcon />}
					onclick={onViewQuote}
				/>
			</Box>
		</Box>
	);
};

export default QuoteCard;
